import { Action } from '@ngrx/store';

import { IWorkflowTask } from '@mediahaven/shared';

export enum TaskActionTypes {
    AddOrUpdate = '[Tasks] Add or update',
    Remove = '[Tasks] Remove',
    Update = '[Tasks] Update',
    Clear = '[Tasks] Clear'
}

export class AddOrUpdateTask implements Action {
    readonly type: TaskActionTypes.AddOrUpdate = TaskActionTypes.AddOrUpdate;
    constructor(public task: IWorkflowTask) {}
}

export class UpdateTask implements Action {
    readonly type: TaskActionTypes.Update = TaskActionTypes.Update;
    constructor(
        public id: string,
        public changes: Partial<IWorkflowTask>
    ) {}
}

export class RemoveTask implements Action {
    readonly type: TaskActionTypes.Remove = TaskActionTypes.Remove;
    constructor(public id: string) {}
}

export class ClearTasks implements Action {
    readonly type: TaskActionTypes.Clear = TaskActionTypes.Clear;
}

export type TaskAction = AddOrUpdateTask | UpdateTask | RemoveTask | ClearTasks;
